
import { Injectable } from '@angular/core';
import { ReportingService } from './general.service';
import { AngularFirestore } from 'angularfire2/firestore';

// services
import { DBContextFirebaseService } from '../../db-context/db-context.firebase.service';
import { User } from 'app/core/user';

@Injectable()
export class ReportingFirebaseService implements ReportingService {

    constructor(
        private afDB: AngularFirestore,
        private dBContextFirebaseService: DBContextFirebaseService

    ) { }

    async getAllUsers(): Promise<User[]> {
        const collection = this.afDB.firestore.collection('users')
        return this.dBContextFirebaseService.getCollection(collection)
    }


    async getUserColl(colName: string): Promise<firebase.firestore.DocumentSnapshot[]> {
        return await this.afDB.firestore
            .collection(colName)
            .get()
            .then(querySnapShot => {
                if (querySnapShot) {
                    return querySnapShot.docs
                } else {
                    return null
                }
            })
    }

    async getUserCollDoc(colName: string, docName: string, colName2: string): Promise<firebase.firestore.DocumentSnapshot[]> {
        return await this.afDB.firestore
            .collection(colName)
            .doc(docName)
            .collection(colName2)
            .get()
            .then(querySnapShot => {
                if (querySnapShot) {
                    return querySnapShot.docs
                } else {
                    return null
                }
            })
    }

    async getUserCollDocCol(colName: string, docName: string, colName2: string,
        docName2: string): Promise<firebase.firestore.DocumentSnapshot> {
        return await this.afDB.firestore
            .collection(colName)
            .doc(docName)
            .collection(colName2)
            .doc(docName2)
            .get()
            .then(querySnapShot => {
                if (querySnapShot) {
                    return querySnapShot;
                } else {
                    return null
                }
            })
    }
}
